import React from 'react';

interface HeadphonesProps {}

export function Headphones(props: Readonly<HeadphonesProps>) {
	return (
		<svg width={90} height={90} viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_2182_19361)">
				<path
					fill="#999"
					d="M78.975 98.391c.663-.845 3.093-4.588 3.862-5.883.77-1.295 1.735-2.87 2.471-4.379.796-1.63 2.195-4.352 3.2-6.333.857-1.69 4.022-8.012-.817-13.708-2.464-2.129-4.86-2.817-10.131-4.006-7.52-1.697-7.76-.851-14.992-3.683-3.41-1.337-5.121-3.236-6.776-6.08-.574-.988.077-5.432 0-6.364-.07-.838-.899-1.498-1.924-1.498l-20.013-.027c-1.042 0-1.918.672-1.943 1.525-.037 1.26.594 5.296 0 6.365-.887 2.36-3.779 4.691-7.933 6.08-4.13 1.553-6.046 1.929-13.097 3.87-2.448.673-5.92 1.772-7.804 3.192-1.438 1.083-2.739 3.317-3.15 4.757-.41 1.44-.436 4.924.89 8.388 1.326 3.463 3.167 6.4 3.462 7.246.295.846 2.062 4.66 2.652 5.747.589 1.087 2.237 3.934 2.504 4.274.266.34 1.546 2.294 2.062 3.139.294.543 1.207 2.242 1.473 2.776.541 1.09 4.799 8.276 5.167 10.932.53 3.823.958 11.643.958 16.212-.616 7.261-.9 6.322-4.117 21.693-.363 1.733-.265 3.81 0 6.225.731 6.672 5.35 16.149 30.98 16.149 25.631 0 29.491-14.037 29.755-16.149.264-2.113.328-3.63 0-6.225-.327-2.596-3.631-13.539-4.179-21.693-.238-3.545 0-12.581.548-16.212.609-4.038 2.943-9.859 5.07-13.496.422-.721 1.159-1.989 1.822-2.834z"
				/>
				<path
					fill="#7F7F7F"
					d="M33.93 10.845c1.895-1.12 6.372-2.314 9.112-2.314s6.892.209 10.284 2.314c3.39 2.105 4.632 3.663 5.408 4.948.777 1.286 2.49 5.1 3.143 8.27a22.43 22.43 0 01.3 7.347c-.365 3-1.98 8.119-3.359 10.583-1.378 2.464-5.492 9.961-7.51 12.36-2.018 2.4-3.684 3.128-7.915 3.128-3.745 0-6.157-2.185-7.81-3.984-1.653-1.8-6.3-9.683-6.924-10.711-.625-1.029-3.268-6.213-3.685-9.662-.416-3.449-.325-6.939 0-9.062.326-2.123 1.694-5.762 3.32-8.269 1.626-2.506 3.742-3.83 5.636-4.948z"
				/>
				<mask
					id="a"
					x={13}
					y={1}
					width={61}
					height={42}
					maskUnits="userSpaceOnUse"
					style={{ maskType: 'luminance' }}
				>
					<path d="M13.238 1h60.246v41.338H13.238V1z" fill="#fff" />
				</mask>
				<g mask="url(#a)">
					<path
						fill="#445662"
						d="M22.74 42.281h1.156c1.532 0 2.774-1.073 2.774-2.397l-.74-11.773c0-1.323-.502-2.237-2.034-2.237H22.74c-.975 0-1.917.127-2.803.364V22.58c0-10.131 10.508-18.374 23.423-18.374s23.423 8.243 23.423 18.374v3.658a10.874 10.874 0 00-2.803-.364h-1.156c-1.532 0-1.529.914-1.529 2.237L60.05 39.884c0 1.324 1.242 2.397 2.774 2.397h1.156c5.244 0 9.495-3.673 9.495-8.204 0-2.35-1.147-4.47-2.982-5.966v-5.53C70.493 10.68 58.32 1 43.36 1 28.4 1 16.227 10.68 16.227 22.58v5.531c-1.834 1.497-2.98 3.615-2.98 5.966 0 4.531 4.25 8.204 9.493 8.204z"
					/>
				</g>
				<path
					fill="#445662"
					d="M46.926 53.716v-2.79c8.493 0 12.445-.792 14.582-2.921 2.158-2.15 2.961-6.108 2.961-14.603h3.008c0 8.076-.616 13.364-3.767 16.503-3.199 3.188-8.576 3.811-16.784 3.811z"
				/>
				<mask
					id="b"
					x={43}
					y={48}
					width={9}
					height={6}
					maskUnits="userSpaceOnUse"
					style={{ maskType: 'luminance' }}
				>
					<path d="M43.215 48.844h7.901v4.87h-7.901v-4.87z" fill="#fff" />
				</mask>
				<g mask="url(#b)">
					<path
						fill="#445662"
						d="M46.128 48.93h2.083c1.53 0 2.77 1.07 2.77 2.392 0 1.322-1.24 2.393-2.77 2.393h-2.083c-1.529 0-2.769-1.071-2.769-2.393 0-1.321 1.24-2.392 2.77-2.392z"
					/>
				</g>
				<path
					fill="#999"
					d="M3.891 133.539c-.768.911-1.666 1.633-2.642 2.126a6.725 6.725 0 01-3.045.745 6.373 6.373 0 01-2.983-.75c-.935-.494-1.773-1.218-2.467-2.13-1.063-1.394-1.981-3.882-2.018-5.092a51.242 51.242 0 01-.018-2.88c.045-1.985.27-3.082.63-5.036.733-3.929.668-3.064 1.406-6.469.482-4.252 1.092-7.746 1.445-15.843.22-5.244.787-10.479 1.697-15.65.25-1.266.492-2.458.693-3.541l.013-.13c.35-1.517.66-2.927.92-4.005.593-1.779 1.484-3.396 2.61-4.739 1.13-1.334 2.45-2.39 3.883-3.106 1.434-.717 2.953-1.082 4.47-1.073 1.518.01 3.008.185 4.372 1.126 1.367 1.028 2.156 2.271 2.56 2.99.528.941 2.324 3.282 2.899 9.364.151 1.6.012 3.33-.03 3.755-.043.425.042-.393 0 0-.454 4.508-1.33 8.574-2.54 12.767-1.222 4.231-2.558 7.275-2.558 7.275-1.213 3.18-1.53 3.678-2.494 6.558-.879 2.626-1.787 5.916-2.554 8.761-.54 2.875-1.551 6.926-1.776 8.075-.37 1.894-.485 3.058-.91 4.243-.425 1.185-.81 1.749-1.563 2.659zM86.109 133.539c.768.911 1.666 1.633 2.642 2.126.976.493 2.01.746 3.045.745a6.373 6.373 0 002.983-.75c.935-.494 1.773-1.218 2.467-2.13 1.064-1.394 1.981-3.882 2.018-5.092.024-.787.047-1.873.018-2.88-.045-1.985-.27-3.082-.63-5.036-.733-3.929-.668-3.064-1.406-6.469-.483-4.252-1.092-7.746-1.445-15.843a119.015 119.015 0 00-1.697-15.65c-.25-1.266-.492-2.458-.693-3.541l-.013-.13c-.35-1.517-.66-2.927-.92-4.005-.593-1.779-1.484-3.396-2.61-4.739-1.13-1.334-2.45-2.39-3.883-3.106-1.434-.717-2.953-1.082-4.47-1.073-1.518.01-3.008.185-4.372 1.126-1.367 1.028-2.156 2.271-2.56 2.99-.528.941-2.324 3.282-2.899 9.364-.151 1.6-.012 3.33.03 3.755.043.425-.042-.393 0 0 .454 4.508 1.33 8.574 2.54 12.767 1.222 4.231 2.558 7.275 2.558 7.275 1.213 3.18 1.53 3.678 2.493 6.558.88 2.626 1.788 5.916 2.555 8.761.54 2.875 1.551 6.926 1.776 8.075.37 1.894.485 3.058.91 4.243.424 1.185.81 1.749 1.563 2.659z"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2182_19361">
					<path fill="#fff" d="M0 0H90V90H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
